import { createSelector } from '@reduxjs/toolkit';

import { CLUSTERS_FIELDS } from 'shared/constants/map';
import { ListingByPinSortType } from 'shared/types/ListingSortType';

import { useReduxSelector } from '../../../external/hooks';
import { MapSelectedBounds } from '../slice';

import { mapControlsSelector } from './root';

export const mapControlsIsCurrentAreaSearchActiveSelector = createSelector(
  mapControlsSelector,
  state => state.isCurrentAreaSearchActive,
);

export function useMapControlsIsCurrentAreaSearchActiveSelector(): boolean {
  return useReduxSelector(mapControlsIsCurrentAreaSearchActiveSelector);
}

export const activePinSelector = createSelector(mapControlsSelector, state => state.activePin);

export const activePinIdSelector = createSelector(activePinSelector, activePin => activePin?.id);

export function useActivePinIdSelector(): string | undefined {
  return useReduxSelector(activePinIdSelector);
}

export const activePinListingIdSelector = createSelector(
  activePinSelector,
  activePin => activePin?.properties?.[CLUSTERS_FIELDS.listingId],
);

export function useActivePinListingIdSelector(): string | undefined {
  return useReduxSelector(activePinListingIdSelector);
}

export const activePinPageSelector = createSelector(mapControlsSelector, state => state.activePinPage);

export function useActivePinPageSelector(): number | undefined {
  return useReduxSelector(activePinPageSelector);
}

export const mapSelectedBoundsSelector = createSelector(mapControlsSelector, state => state.selectedBounds);
export function useMapSelectedBoundsSelector(): MapSelectedBounds | undefined {
  return useReduxSelector(mapSelectedBoundsSelector);
}

export const activePinSortSelector = createSelector(mapControlsSelector, state => state.activePinSort);
export function useActivePinSortSelector(): ListingByPinSortType {
  return useReduxSelector(activePinSortSelector);
}
